import { InteractiveText } from '@silvertours/front-shared';

type DeleteButtonInteractiveTextProps = {
  className?: string;
};

const DeleteButtonInteractiveText: React.FC<
  React.PropsWithChildren<DeleteButtonInteractiveTextProps>
> = ({ children, className }) => (
  <InteractiveText
    className={className}
    size="small"
    inline
    textColor="current"
  >
    {children}
  </InteractiveText>
);

export { DeleteButtonInteractiveText };
